import { GanttInfo } from "../entities/entities";
import { EntityManager, Repository } from "aurelia-orm";
import { autoinject } from 'aurelia-dependency-injection';

@autoinject()
export class GanttInfoService {

	saveItem(item) {
		const cleaned = this.prepItemForSave(item);
		this.repository.transport.post(this.repository.getResource() + "/updateItem", item);
	}

	//We need to send only the item, not the entire tree.
	prepItemForSave(item: GanttInfo): GanttInfo {
		let clone = Object.assign({}, item);
		clone.children = null;
		return clone;
	}

//saveFieldEdit(id: number, fieldName: string, value: any) {
//	this.repository.transport.post(this.repository.getResource() + "/updateField", { id: id, fieldName: fieldName, value: value });
//}
	getNew(): any {
		return this.repository.getNewEntity();
	}

	repository: Repository;
	constructor(private entityManager: EntityManager) {
		this.repository = this.entityManager.getRepository(GanttInfo);
	}

	//Matches /api/ganttinfo on server.
	find(parentId:number) {
		return this.repository.find(parentId);
	}

	
}